<div class="mysusernotificationscrolldiv">
  <div class="d-flex round-borders">
    @if (!showInfoMessage()) {
      <div class="message-info">
        <label><b>{{noSavedNotificationsMessage}}</b></label>
      </div>
    }

    @if (showInfoMessage()) {
      <div class="d-flex flex1">
        <p-table [value]="notifications" styleClass="pulte-scrollflex-table p-datatable-striped p-datatable-gridlines" class="pulte-scrollflex-table" responsiveLayout="scroll">
          <ng-template #header>
            <tr>
              <th style="flex: 3;">Notifications</th>
              <th style="flex: 1;"></th>
            </tr>
          </ng-template>
          <ng-template #body let-notification>
            <tr>
              <td style="flex: 3;">
                {{notification.notificationTypeName}}
              </td>
              <td class="text-center" style="flex: 1;">
                <a>
                  <i class="fas fa-lg fa-pencil-alt" title="View/Edit Notification"
                  (click)="showEditSideBar(notification)"></i>
                </a>
                <a>
                  <i class="fas fa-lg fa-trash pl-2" title="Delete"
                  (click)="deleteNotificationSettings(notification)"></i>
                </a>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    }
  </div>
</div>

<add-edit-notifications #addEditNotificationComp (refreshGridFromChildEvent)="getSaveUpdateFromSidePanel($event)"
[excludedNotificationTypes]="ExcludedTypes" />

<pcp-commandbar [isPositionFixed]="true">
  <command-button button-right [text]="ButtonText.AddNotification" [iconClasses]="['fa-2x fa-plus fas']"
    [enabled]="AnyValidTypes" (commandClick)="showAddSideBar()" />
</pcp-commandbar>